import React from "react";
import { calculateWidthAndHeightOffset } from "../../../Helpers/Utility";
import { Player, Shortcut } from "video-react";
import { ChatAudioSender2Hoc } from "../../../assets/images";

const VideoPlayer = (props = {}) => {
  const [getVideoPlayer, setVideoPlayer] = React.useState({
    visibility: false,
    webWidth: 0,
    webHeight: 0,
    palyStatus: true,
  });
  const { url,fileType } = props;

  React.useEffect(() => {
    const parentElement =
      window.document && document.getElementById(`video-wrapper-0`);
    const captionElement =
      window.document && document.getElementById(`uploadImageCaption`);
    if (parentElement) {
      const { offsetWidth, offsetHeight } = parentElement;
      let captionHeight = 0;
      if (captionElement)
        captionHeight = captionElement.offsetHeight + props.captionMargin;
      const { webWidth: newWidth, webHeight: newHeight } =
        calculateWidthAndHeightOffset(
          props.webWidth,
          props.webHeight,
          offsetWidth,
          offsetHeight - captionHeight
        );
      setVideoPlayer({
        webWidth: newWidth,
        webHeight: newHeight,
        visibility: true,
      });
    }
  }, []);

  return (
    <div
      style={{
        maxHeight: getVideoPlayer.webHeight,
        height: "100%",
        width: "100%",
        maxWidth: getVideoPlayer.webWidth,
      }}
    >
      {fileType === "audio" && (
        <i className={`AudioDetails ${getVideoPlayer.palyStatus === true ? "default" : ""}`}>
          {fileType !== "recording" ? <ChatAudioSender2Hoc viewBox="0 0 35 35"/> : <ChatAudioRecorder />}
          <span className="audioDuration">{props.audioDuration}</span>
        </i>
      )}
      <Player>
        <source src={url} />
        <Shortcut disabled />
      </Player>
    </div>
  );
};

export default VideoPlayer;
